<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4><i class="fas fa-history"></i> Histórico de {{ title }}</h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        :title="`Voltar para aba de ${title}`"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div class="col-md-6 mb-3" v-for="item in itens" :key="item.id">
            <div class="card border" v-if="item.data">
                <div class="card-header bg-gray">
                    <p><b>Data</b> {{ item.data }}</p>
                    <p><b>Técnico</b> {{ item.tecnico }}</p>
                </div>
                <div class="card-body">
                    <p>
                        <b>Possui qualificação profissional? </b>
                        {{ pergunta(item.qualificacao_profissional) }}
                    </p>
                    <p>
                        <b>Neste trabalho principal era: </b>
                        {{
                            verificarResposta(
                                item.profissao_principal,
                                $root.arrays.profissao_principal
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Qual sua profissão de acordo com a CLASSIFICAÇÃO
                            BRASILEIRA DE OCUPAÇÕES ? :</b
                        >
                        {{ item.profissao_nome }}
                    </p>
                    <p>
                        <b>Na semana passada trabalhou? </b>
                        {{ pergunta(item.trabalhou) }}
                    </p>
                    <p>
                        <b
                            >Na semana passada estava afastado de um trabalho,
                            por motivo de doença, falta voluntária, licença,
                            férias ou por outro motivo? :</b
                        >
                        {{ pergunta(item.afastado) }}
                    </p>
                    <p>
                        <b
                            >Esse trabalho principal que exerceu foi na
                            agricultura, criação de animais, pesca ou coleta
                            (extração vegetal)? :</b
                        >
                        {{ pergunta(item.trabalho_agricultura) }}
                    </p>
                    <p>
                        <b>No mês passado recebeu remuneração de trabalho? </b>
                        {{ pergunta(item.recebeu_remuneracao) }}
                    </p>
                    <p>
                        <b
                            >(Se sim, registre o valor bruto da remuneração
                            efetivamente recebida)
                        </b>
                        {{ item.valor_remuneracao }}
                    </p>
                    <p>
                        <b>Trabalhou remunerado nos últimos 12 meses? </b>
                        {{ pergunta(item.remuneracao_12_meses) }}
                    </p>
                    <p>
                        <b>Quantos meses trabalhou? </b>
                        {{ item.qtd_meses_trabalhados }}
                    </p>
                    <p>
                        <b>Valor bruto de todos os trabalhos? </b>
                        {{ item.remuneracao_valor_bruto }}
                    </p>
                    <p>
                        <b>Recebe aposentadoria por algum desses motivos: </b>
                        {{
                            verificarResposta(
                                item.aposentadoria_motivo,
                                $root.arrays.aposentadoria_motivo
                            )
                        }}
                    </p>
                    <p>
                        <b>Valor da Aposentadoria </b>
                        {{ item.aposentadoria_valor }}
                    </p>
                    <p>
                        <b>Recebe algum desses benefícios </b>
                        {{
                            verificarResposta(
                                item.beneficio,
                                $root.arrays.beneficios
                            )
                        }}
                    </p>
                    <p>
                        <b>Valor do Beneficiário </b> {{ item.beneficio_valor }}
                    </p>
                    <p><b>Valor Doação </b> {{ item.doacao_valor }}</p>
                    <p>
                        <b>Valor Pensão alimentícia </b>
                        {{ item.pensao_alimentar_valor }}
                    </p>
                    <p>
                        <b>Valor Seguro-desemprego </b>
                        {{ item.seguro_desemprego_valor }}
                    </p>
                    <p><b>Outras Rendas </b> {{ item.outras_rendas_valor }}</p>
                    <p><b>Renda Total </b> {{ item.total_rendas }}</p>
                </div>
            </div>
            <div v-else>
                <div v-if="itens.length <= 1">
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Não possui histórico ainda.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Historico",
    props: ["id", "tipo", "title"],
    data() {
        return {
            loading: true,
            itens: {},
        };
    },
    mounted() {
        this.getItens();
    },
    methods: {
        getItens() {
            axios
                .get(`api/dashboard/usuarios/historico/${this.tipo}/${this.id}`)
                .then((response) => {
                    this.itens = response.data;
                    this.loading = false;
                });
        },

        dateConverter(date) {
            if (date) {
                return moment(date).format("DD/MM/YYYY");
            } else {
                return "";
            }
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            const result = array.filter((item) => item.id == resposta);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>
